// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__2jd7n","section":"section__-5bfd","contactus":"contactus__1-usf","findus":"findus__1WpO1","header":"header__1jo_O","copyright":"copyright__Vtwjz"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.css
// module id = ZMjw
// module chunks = 3